/* eslint-disable @next/next/no-img-element */
import cx from 'classnames';

import { useFooter } from 'hooks/page/footer/useFooter';

import s from './PlayfulFooter.module.css';
import s1 from 'themes/playful/components/PlayfulLayout.module.css';

export const PlayfulFooter = () => {
  const {
    address,
    termsOfServiceUrl,
    privacyPolicyUrl,
    addressLink,
    showAddress,
  } = useFooter();

  return (
    <footer className={s.footer}>
      <div className={cx(s1.content, s.content)}>
        {showAddress && (
          <a
            href={addressLink}
            className={s.address}
            target="_blank"
            rel="noopener noreferrer"
          >
            {address}
          </a>
        )}

        <a
          href="https://glossgenius.com"
          className={s.logo}
          target="_blank"
          rel="noopener noreferrer"
        >
          <span className={s.poweredByLabel}>powered by</span>
          <img src="/assets/logos/GG_Logo_White.svg" alt="GlossGenius" />
        </a>

        <div className={s.links}>
          <a
            href={termsOfServiceUrl}
            className={s.linksItem}
            target="_blank"
            rel="noopener noreferrer"
          >
            Terms
          </a>
          <a
            href={privacyPolicyUrl}
            className={s.linksItem}
            target="_blank"
            rel="noopener noreferrer"
          >
            Privacy Policy
          </a>
        </div>
      </div>
    </footer>
  );
};
